"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var libzl_1 = require("../libzl/libzl");
var ActionTypes_1 = require("../ActionTypes");
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
var metadata_1 = require("../libzl/metadata");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: stretch;\n\talign-content: stretch;\n\tjustify-content: stretch;\n\tflex-wrap: nowrap;\n\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\n\t@media ", " {\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t\tleft: auto;\n\t\tright: auto;\n\t}\n\n"], ["\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: stretch;\n\talign-content: stretch;\n\tjustify-content: stretch;\n\tflex-wrap: nowrap;\n\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\n\t@media ", " {\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t\tleft: auto;\n\t\tright: auto;\n\t}\n\n"])), function (props) { return props.theme.breakpoints.S; });
var Environment = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\theight: 100%;\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tpadding: 0;\n\t\n\tmargin: 0 12px;\n\n\t&:first-child {\n\t\tmargin-left: 0;\n\t}\n\t&:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\tmin-width: 128px;\n\n\t@media ", " {\n\t\tflex-shrink: 0;\n\t\tmargin: 6px 0;\n\t\tmin-height: calc(100vw - 24px);\n\t}\n\n\tborder-top:  ", ";\n\n\t", ";\n"], ["\n\tposition: relative;\n\theight: 100%;\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\tpadding: 0;\n\t\n\tmargin: 0 12px;\n\n\t&:first-child {\n\t\tmargin-left: 0;\n\t}\n\t&:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\tmin-width: 128px;\n\n\t@media ", " {\n\t\tflex-shrink: 0;\n\t\tmargin: 6px 0;\n\t\tmin-height: calc(100vw - 24px);\n\t}\n\n\tborder-top:  ", ";\n\n\t", ";\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.selected ? ('8px solid ' + props.theme.selectionHighlightCol) : 'none'; }, function (props) { return props.theme.layout.focusAccent; });
var Image = styled_components_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\n\tobject-fit: cover;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\n\tobject-fit: cover;\n"])));
;
;
var EnvironmentSelect = /** @class */ (function (_super) {
    __extends(EnvironmentSelect, _super);
    function EnvironmentSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelect = function (environment) {
            libzl_1.changeEnvironment(environment);
            // optimistic environment update:
            _this.props.updateEnv(environment);
            _this.props.onClose();
        };
        _this.state = {
            current: _this.props.current
        };
        // will correct the env selection if it has changed underneath us (should be rare except during dev)
        libzl_1.checkCurrentEnv(_this.props.updateEnv);
        return _this;
    }
    EnvironmentSelect.prototype.render = function () {
        var _this = this;
        var environments = this.props.environments.filter(function (environment) { return metadata_1.isEnvironmentAvailable(environment.id); });
        environments.sort(function (lhs, rhs) { return metadata_1.getEnvironmentSortKey(lhs.id) - metadata_1.getEnvironmentSortKey(rhs.id); });
        return (react_1.default.createElement(components_1.MessageDialog, { altTheme: true, title: utils_1.formatMessage(this.props.intl, { id: "envselect.title", defaultMessage: "Select Environment" }), onClose: this.props.onClose, closeTooltip: "Close" },
            react_1.default.createElement(Container, null, environments.map(function (environment) {
                return (react_1.default.createElement(Environment, { selected: environment.id === _this.props.current, key: environment.id, onClick: function () { return _this.onSelect(environment.id); }, "aria-label": environment.name, "data-automationid": environment.id },
                    react_1.default.createElement(Image, { src: environment.image, alt: environment.name })));
            }))));
    };
    return EnvironmentSelect;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        environments: store.UI.environments.available,
        current: store.UI.environments.current
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        updateEnv: function (current) {
            var env = current;
            if (window.zlurlparams.localstream) {
                env = env.toLowerCase();
            }
            dispatch({
                type: ActionTypes_1.UPDATE_ENVIRONMENT,
                data: env
            });
        }
    };
};
exports.default = react_redux_1.connect(MapStoreToProps, mapDispatchToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(EnvironmentSelect)));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=EnvironmentSelect.js.map